export default {
  label: '销售专员',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '销售专员是销售团队的基础岗位，主要负责开拓市场、完成销售目标，以及维护客户关系等工作',
          id: '0-1-1',
        }
      ]
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '开拓市场，寻找销售机会，完成销售业绩',
          id: '0-2-1',
        },
        {
          label: '通过与客户有效沟通了解客户需求，挖掘潜在客户',
          id: '0-2-2',
        },
        {
          label: '维护客户关系，提高客户满意度，收集行业及竞争对手信息',
          id: '0-2-3',
        },
        {
          label: '参与商务谈判，签订合同，并提供售前咨询',
          id: '0-2-4',
        },
        {
          label: '跟踪订单进度，处理客户投诉，提升客户满意度',
          id: '0-2-5',
        },
        {
          label: '协助制定销售计划和策略',
          id: '0-2-6',
        }
      ]
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '大专以上学历，熟悉互联网和办公软件操作',
          id: '0-3-1',
        },
        {
          label: '具有强烈进取精神和执行力',
          id: '0-3-2',
        },
        {
          label: '良好的沟通能力和团队合作精神',
          id: '0-3-3',
        }
      ]
    }
  ]
}